import { createStyles, Stack, Text } from '@mantine/core';
import React from 'react';

const useStyles = createStyles((theme, type: any) => ({
  stack: {
    fontSize: { accordion: theme.fontSizes.lg }[type] || theme.fontSizes.md,
  },
  entry: {
    gap: { accordion: '0' }[type] || 8,
    lineHeight: { accordion: '150%' }[type] || 'normal',
  },
}));

export type DescriptionListProps = {
  type?: 'default' | 'accordion';
  sections?: {
    uuid?: string;
    title?: string;
    entries?: {
      uuid?: string;
      label?: string;
      children?: React.ReactNode | React.ReactNode[];
    }[];
  }[];
};

const DescriptionList = ({
  type = 'default',
  sections = [],
  ...rest
}: DescriptionListProps) => {
  const { classes } = useStyles(type);

  return (
    // @ts-ignore
    <Stack spacing="xl" type={type} {...rest} className={classes.stack}>
      {sections &&
        sections.map(({ uuid, title, entries }) => (
          <Stack spacing={{ accordion: 8 }[type] || 16} key={uuid}>
            {title && (
              <Text
                fw="700"
                c={{ accordion: 'default.9' }[type] || 'primary.9'}
              >
                {title}
              </Text>
            )}
            {entries.map(({ uuid: uuidInner, label, children }) => (
              <Stack
                fw="300"
                c={{ accordion: 'default.9' }[type] || 'primary.9'}
                className={classes.entry}
                key={uuidInner}
              >
                <Text
                  fw="700"
                  c={{ accordion: 'fgMuted.5' }[type] || 'primary.9'}
                >
                  {label}
                </Text>
                {children}
              </Stack>
            ))}
          </Stack>
        ))}
    </Stack>
  );
};

export default DescriptionList;
